import React from "react";
import "./ThresholdBG.css";
import { calculateProgress } from "../../../utils/helper";
const ThresholdBG = ({ configData }) => {
  const { color, width } = calculateProgress(configData);
  const thresholds =
    configData?.config?.setThresholds && configData?.config?.thresholds;
  let percentages;
  if (!thresholds) percentages = [75, 25];
  else {
    const min = thresholds.min;
    const max = thresholds.max;
    const firstWidth = (min * 75) / 100;
    const secondWidth = ((max - min) * 75) / 100;
    const thirdWidth = ((100 - max) * 75) / 100;
    percentages = [firstWidth, secondWidth, thirdWidth, 25];
  }

  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 120 120"
      className={`threshold-bg-speedometer ${
        thresholds ? "thresholds" : "no-thresholds"
      }`}
    >
      {percentages.map((percentage, index) => {
        const strokeDash = (percentage / 100) * circumference;
        offset += strokeDash;
        const strokeDashOffset = circumference + offset;

        return (
          <circle
            key={index}
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            strokeWidth={4}
            strokeDasharray={`${strokeDash} ${circumference}`}
            strokeDashoffset={-strokeDashOffset}
            transform="rotate(135 60 60)"
          />
        );
      })}
      {width > 0 && (
        <circle
          cx="60"
          cy="60"
          r={radius}
          fill="none"
          strokeWidth={4}
          style={{ stroke: color }}
          strokeDasharray={`${
            (((circumference * 75) / 100) * width) / 100
          } ${circumference}`}
          strokeDashoffset={0}
          transform="rotate(135 60 60)"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
};
export default ThresholdBG;
